import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
export function MainCTA() {
  const {
    t
  } = useLanguage();
  return <section id="contacto" className="py-32 bg-brand-green-dark relative overflow-hidden" data-id="element-181">
      {/* Dynamic background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-green-dark via-brand-green to-brand-green-dark opacity-90" data-id="element-182"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-184">
          <div className="inline-block bg-brand-gold text-brand-bg-dark font-heading font-bold tracking-widest px-6 py-2 mb-8 rounded-full uppercase text-sm sm:text-base shadow-lg" data-id="element-185">
            {t('cta.badge')}
          </div>

          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-white mb-12 drop-shadow-lg leading-tight uppercase" data-id="element-186">
            {t('cta.title1')} <br className="hidden sm:block" data-id="element-187" />
            <span className="text-brand-gold" data-id="element-188">{t('cta.title2')}</span>
          </h2>

          <div className="bg-brand-bg-dark/90 backdrop-blur-md p-8 sm:p-12 rounded-3xl border-2 border-brand-gold/50 shadow-[0_0_60px_rgba(200,169,81,0.2)] max-w-3xl mx-auto mb-12" data-id="element-189">
            <p className="text-2xl sm:text-3xl text-gray-300 font-medium mb-4" data-id="element-190">
              {t('cta.p1')}
            </p>
            <p className="text-3xl sm:text-4xl font-heading font-bold text-white mb-8" data-id="element-191">
              {t('cta.p2')}
            </p>

            <motion.a href="tel:2029132653" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex flex-col sm:flex-row items-center justify-center gap-4 bg-brand-gold hover:bg-brand-gold-light text-brand-bg-dark px-8 sm:px-12 py-6 rounded-2xl font-heading font-bold text-4xl sm:text-5xl md:text-6xl tracking-wider transition-all duration-300 shadow-[0_0_40px_rgba(200,169,81,0.5)] w-full sm:w-auto" data-id="element-192">
              <PhoneIcon className="w-10 h-10 sm:w-12 sm:h-12" data-id="element-193" />
              (202) 913-2653
            </motion.a>

            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-6 text-lg sm:text-xl text-brand-gold font-medium tracking-wide" data-id="element-194">
              <span className="flex items-center gap-2" data-id="element-195">
                <span className="w-3 h-3 bg-brand-gold rounded-full animate-pulse" data-id="element-196"></span>
                {t('cta.available')}
              </span>
              <span className="hidden sm:block text-gray-600" data-id="element-197">|</span>
              <span data-id="element-198">MD • DC • VA</span>
            </div>
            <p className="text-gray-400 mt-4" data-id="element-199">{t('cta.location')}</p>
          </div>

          <blockquote className="text-2xl sm:text-3xl font-heading font-medium text-white italic max-w-4xl mx-auto drop-shadow-md" data-id="element-200">
            {t('cta.quote1')}
            <span className="text-brand-gold font-bold" data-id="element-201">{t('cta.quote2')}</span>
            {t('cta.quote3')}
          </blockquote>
        </motion.div>
      </div>
    </section>;
}